export default {
    jp: {
        LP: {
            nav: [{
                    name: "TOP",
                    id: "nav-top"
                },
                {
                    name: "メッセージ",
                    id: "nav-message"
                },
                {
                    name: "体験する",
                    id: "nav-expenrise"
                },
                {
                    name: "アーティスト",
                    id: "nav-artist"
                },
                {
                    name: "作品の植樹地",
                    id: "nav-place"
                },
                {
                    name: "みんなで作るDANDELION",
                    id: "nav-result"
                },
                // {
                //     name: "植樹支援のお願い",
                //     id: "nav-contribution"
                // },
                {
                    name: "サポーター",
                    id: "nav-supporters"
                },
                {
                    name: "お問い合わせ",
                    id: "nav-supporters"
                },
            ],
            top_desc_mb: "「DANDELION」は、世界と繋がるアート。\n\nタンポポに息を吹きかけると、\n舞い上がった綿毛がネットワークを通じて\n世界中に舞い、\n各地に設置された「DANDELION」のそばで\n花を咲かせます。\n\n集まってきた花々は、\nやがて美しい花畑へと育ちます。\n\n「世界に平和が訪れますように」\n「より良い世界になりますように」\nあなたの願いを綿毛に乗せて、\n世界に花を咲かせましょう。",
            top_desc_pc: "「DANDELION」は、世界と繋がるアート。\n\nタンポポに息を吹きかけると、\n舞い上がった綿毛がネットワークを通じて世界中に舞い、\n各地に設置された「DANDELION」のそばで花を咲かせます。\n集まってきた花々は、やがて美しい花畑へと育ちます。\n\n「世界に平和が訪れますように」\n「より良い世界になりますように」\nあなたの願いを綿毛に乗せて、\n世界に花を咲かせましょう。",
            msg: {
                msg_title: "メッセージ",
                msg_desc_mb: "2020年以降、あらゆる面で世界が変化していく中で、僕たちはどのように世界と、そして他者と繋がっていくのか。\n\n誰もが発信力を持ち、誰とでもコミュニケーションが取れる時代。\n言葉での主義主張によって\"一つの正しさ\"を訴え合うとキリがありませんが、平和や平穏を願う優しい感情を通して、人の心が繋がり合う方法もあると信じたいです。\n\n「DANDELION」はとてもシンプルな行為によって世界中の人々を繋ぐ作品です。タンポポに願いを込めて吹く、という誰もが子供の頃に遊んだ原体験的な行為と、 世界各地で瞬時に花が咲くスケールが合わさったこの作品を、僕自身とても気に入っています。\n\n花は言葉を必要とせず、物事を分け隔てることもしません。種子を飛ばし、たどり着いた先でまた花を咲かせます。そんな風に、国や人種、思想に関わらず、皆がアートを通して繋がり、世界中に花を咲かせることができればと願っています。",

                msg_desc_pc: "2020年以降、あらゆる面で世界が変化していく中で、\n僕たちはどのように世界と、そして他者と繋がっていくのか。\n\n誰もが発信力を持ち、誰とでもコミュニケーションが取れる時代。\n言葉での主義主張によって\"一つの正しさ\"を訴え合うとキリがありませんが、\n平和や平穏を願う優しい感情を通して、人の心が繋がり合う方法もあると信じたいです。\n\n「DANDELION」はとてもシンプルな行為によって世界中の人々を繋ぐ作品です。\nタンポポに願いを込めて吹く、という誰もが子供の頃に遊んだ原体験的な行為と、\n 世界各地で瞬時に花が咲くスケールが合わさったこの作品を、僕自身とても気に入っています。\n\n花は言葉を必要とせず、物事を分け隔てることもしません。\n種子を飛ばし、たどり着いた先でまた花を咲かせます。\nそんな風に、国や人種、思想に関わらず、皆がアートを通して繋がり、\n世界中に花を咲かせることができればと願っています。",
                msg_foot: "村松亮太郎 / NAKED"
            },
            art: {
                title1: "アーティスト",
                title2: "Ryotaro Muramatsu / NAKED",
                title3: "ARTIST",
                desc1: "アーティスト。NAKED, INC.代表。1997年にクリエイティブカンパニーNAKED Inc.を設立以来、映画やテレビ、MV、広告、空間演出など、ジャンルを超えてさまざまなプロジェクトを率いてきた。",
                desc2: "アーティスト。NAKED, INC.代表。1997年にクリエイティブカンパニーNAKED Inc.を設立以来、映画やテレビ、MV、広告、空間演出など、ジャンルを超えてさまざまなプロジェクトを率いてきた。監督作品は長編/短編合わせて国際映画祭で48ノミネート&受賞。近年では「FLOWERS BY NAKED」「TOKYO ART CITY BY NAKED」などのイマーシブ(没入型)イベントや、華道・茶道・香道・歌舞伎・能狂言といった伝統文化・芸能と先進の表現を掛け合わせたインスタレーションや公演を手がける。大阪芸術大学で客員教授を務めるほか、ブランディング・ディレクターを務める長野県・阿智村をはじめ大阪府・堺市や佐賀県など日本各地での地方創生イベントや文化プロジェクトに取り組む。2018年には個人アーティストとしての創作活動を開始し、国内外で作品を発表してきた。2019年、イタリア・ヴェネツィアで軽井沢ニューアートミュージアムの主催展「DIVERSITY FOR PEACE!」や、中国・蘇州で開催されたSUZHOU DESIGN WEEKに参加。香港ではHQUEENSのホワイトストーンギャラリー香港で海外初の個展「002」を開催するほか、クリスティーズのChristie's Autumn Auctions Hong Kong 2019でクリスティーズの上顧客を招いたディナーパーティの演出を手がけた。2020年には、分断の時代に平和への祈りで世界を繋ぐネットワーク型のアートプロジェクト「DANDELION PROJECT」を立ち上げ、世界各地での作品設置に取り組む。",
            },
            experrience: {
                text_title1: '体験する',
                text_title2_mb: "あなただけの綿毛を\n世界に届けましょう",
                text_title2_pc: "あなただけの綿毛を世界に届けましょう",
                text_btn: '「DANDELION」\nを体験する',
                text_link: '支援する',
                text_desc: "このプロジェクトを支援し、\n「DANDELION」を世界中に植樹しましょう",
            },
            result: {
                text_title1_mb: "みんなで作る\nDANDELION",
                text_title1_pc: "みんなで作るDANDELION",
                text_title2: "FRIENDS OF\nDANDELION PROJECT",
                text_desc: "作品を体験したみんなの綿毛はここに集まり、\n新しいDANDELIONを生み出します。",
                names: [{
                    firstName: "佐野光咲",
                    lastName: ""
                }, {
                    firstName: "佐野正騎",
                    lastName: ""
                }, {
                    firstName: "NOBU. MARUYAMA",
                    lastName: ""
                }, {
                    firstName: "JUN TERAYAMA",
                    lastName: ""
                }, {
                    firstName: "Ryuta Shimba",
                    lastName: ""
                }, {
                    firstName: "Shinsaku Nakagawa",
                    lastName: ""
                }, {
                    firstName: "Reiji Higashimaki",
                    lastName: ""
                }, {
                    firstName: "Erina",
                    lastName: ""
                }, {
                    firstName: "衞藤登喜子",
                    lastName: ""
                }, {
                    firstName: "深田しのぶ",
                    lastName: ""
                }, {
                    firstName: "小林優人",
                    lastName: ""
                }, {
                    firstName: "松田英樹",
                    lastName: ""
                }, {
                    firstName: "衞藤正和",
                    lastName: ""
                }, {
                    firstName: "衞藤弥保",
                    lastName: ""
                }]
            },
            placeText: {
                title: "作品の植樹地",
                desc_mb: "世界中で「DANDELION」の植樹（設置）を\n進めています。",
                desc_pc: "世界中で「DANDELION」の植樹（設置）を進めています。"
            },
            ctr: {
                title1: "植樹支援のお願い",
                title2: "",
                desc1_mb: "『DANDELION PROJECT』は、\n世界各地に平和の象徴となる\nアート作品「DANDELION」を\n植樹(設置)するための支援金を募集しています。\n世界中に花を咲かせる活動にご参加ください。",
                desc1_pc: "『DANDELION PROJECT』は、\n世界各地に平和の象徴となるアート作品「DANDELION」を\n植樹(設置)するための支援金を募集しています。\n世界中に花を咲かせる活動にご参加ください。",
                desc2: "以下より支援金額をご選択の上、\n「支援する」ボタンを押してください。",
                btn1: "支援する",
                btn2: "支援に関するお問い合わせ",
                input_tips: "金額を入力してください。",
                price_type: "JP¥",
                safari_tips1: "※Safariご使用の方は",
                safari_tips2: "こちらの注意事項",
                safari_tips3: "をご覧ください。",
                safari_setting_tips: "Safariをご利用の方は、以下の設定をご確認ください\n設定＞Safari＞ポップアップブロック＞OFFの\n設定をお願いいたします。",
                min_money_tips: "※50円～入力いただけます。",
                law_tips: '特定商取引法に基づく表記',
                pay_urls: [{
                        name: "JP¥100",
                        url: "https://buy.stripe.com/4gw16J9ea1vN2IMdQS"
                    },
                    {
                        name: "JP¥500",
                        url: "https://buy.stripe.com/eVa02Fbmi5M31EI9AD"
                    }, {
                        name: "JP¥1,000",
                        url: "https://buy.stripe.com/00g02Fcqm1vNfvy7sw"
                    },
                    {
                        name: "JP¥10,000",
                        url: "https://buy.stripe.com/eVabLnfCy6Q7fvy7sx"
                    }
                ]

            },
            supportTitle: "SUPPORTERS",
            contactTitle: "CONTACT US",
            // OGP用情報
            ogp: {
                title: 'DANDELION PROJECT',
                description: '平和への祈りを、アートで繋ぐ。',
                type: 'website',
                url: 'www.breathbless.com',
                site_name: 'DANDELION PROJECT Official Site',
                image: '/Images/Ogp/OGP_breath.jpg',
                twitter_card: 'summary_large_image'
            },

            // タイトル
            title: 'Uniting Prayers for Peace',
            title_sp: 'Uniting' +
                '\r\n' +
                'Prayers' +
                '\r\n' +
                'for' +
                '\r\n' +
                'Peace',

            // サブタイトル
            subtitle: '平和への祈りを、アートで繋ぐ。',

            // ページの詳細
            description: 'これは、世界のあらゆる地点を結びながら、人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして成長し続けます。',
            description_sp: 'これは、世界のあらゆる地点を結びながら、\r\n' +
                '人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、\r\n' +
                '平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして\r\n' +
                '成長し続けます。',

            // Send a Prayerボタンの接続先
            send_url: 'https://naked.co.jp/works/',

            title2: 'SEND A PRAYER',
            title2sp: 'SEND' +
                '\r\n' +
                'A' +
                '\r\n' +
                'PRAYER',
            subtitle2: 'あなたの平和への祈りで世界に花を咲かせましょう。',

            textcontents_qr: '今、『Dandelion』の近くにいる方',
            textcontents_qr_button: 'インタラクティブマーカー',

            textcontents_ol: 'オンラインから作品に参加される方',
            textcontents_ol_button: 'あなたの花を見つける',

            // Send a Prayerボタンから出るモーダルに表示される画像
            // send_modal_image: './Images/LP_dande_contents_0822.jpg',
            // send_modal_image_sp: './Images/LP_dande_SP-contents_0824.jpg',
            // send_modal_image_tb: './Images/LP_dande_ipad_0825.jpg',

            send_modal_image: './Images/maker_jp.jpg',
            // send_modal_image_sp: './Images/maker.jpg',
            // send_modal_image_tb: './Images/maker.jpg',

            // 会社ロゴ
            corporate_logo: './Images/NAKED,INC._Logotype_b.png',

            // 会社ロゴからの接続先
            corporate_url: 'https://naked.co.jp',

            // お問い合わせの接続先
            contact_url: 'https://naked.co.jp/contact/',

            // メッセージ
            //
            // thumbnail => サムネイル画像
            // title => タイトル
            // description => 詳細説明
            message: {
                thumbnail: './Images/RM.jpg',
                title: 'ARTIST',
                name: 'Ryotaro Muramatsu / NAKED ',
                description: 'アーティスト。NAKED, INC.代表。大阪芸術大学客員教授。長野県・阿智村ブランディングディレクター。 1997年にクリエイティブカンパニーNAKED, INC.を設立以来、映画やテレビ、MV、広告、空間演出など、ジャンルを超えてさまざまなプロジェクトを率いてきた。監督作品は長編/短編合わせて国際映画祭で48ノミネート&受賞。近年では「FLOWERS BY NAKED」「TOKYO ART CITY BY NAKED」などのイマーシブ(没入型)イベントや、華道・茶道・香道・歌舞伎・能狂言といった伝統文化・芸能と先進の表現を掛け合わせたインスタレーションや公演を手がける。大阪芸術大学で客員教授を務めるほか、ブランディング・ディレクターを務める長野県・阿智村をはじめ大阪府・堺市や佐賀県など日本各地での地方創生イベントや文化プロジェクトに取り組む。2018年には個人アーティストとしての創作活動を開始し、国内外で作品を発表してきた。',
                message: '2020年、この世界はさまざまな意味で大きく変わりました。' +
                    '\r\n' +
                    '不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。' +
                    '\r\n' +
                    '種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。' +
                    '\r\n' +
                    '\r\n' +
                    '村松 亮太郎',
                message_sp: '『2020年、この世界はさまざまな意味で大きく変わりました。不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。』'
            },

            // サポーターのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            supporters: [{
                    logo: './Images/Supporters/GB Logo SG_4C_Grey.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/sas.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/pds.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/tt.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/kddi.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_venice.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_tokyo.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_capetown.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/gl.png',
                    url: ''
                }
            ],

            // フレンドのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            friends: [{
                    logo: './Images/Friends/friends_sanomisaki.png'
                },
                {
                    logo: './Images/Friends/friends_sanomasaki.png'
                },
                {
                    logo: './Images/Friends/friends_nobu.png'
                },
                {
                    logo: './Images/Friends/friends_jun.png'
                },
                {
                    logo: './Images/Friends/friends_ryuta.png'
                },
                {
                    logo: './Images/Friends/friends_shinsaku.png'
                },
                {
                    logo: './Images/Friends/friends_reiji.png'
                },
                {
                    logo: './Images/Friends/friends_erina.png'
                },
                {
                    logo: './Images/Friends/friends_etotokiko.png'
                },
                {
                    logo: './Images/Friends/friends_fukada.png'
                },
                {
                    logo: './Images/Friends/friends_kobayashi.png'
                },
                {
                    logo: './Images/Friends/friends_kuniya.png'
                },
                {
                    logo: './Images/Friends/friends_matsuda.png'
                },
                {
                    logo: './Images/Friends/friends_etomasakazu.png'
                },
                {
                    logo: './Images/Friends/friends_etomiho.png'
                },
            ],

            // 寄付のお願い
            contribution: {
                title_pc: '『Dandelion』植樹支援（作品設置支援）のお願い',
                title_sp: '『Dandelion』植樹支援（作品設置支援）のお願い',
                message: '「DANDELION PROJECT」は、平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動にぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                message_sp: '「DANDELION PROJECT」は、' +
                    '\r\n' +
                    '平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための' +
                    '\r\n' +
                    '支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動に' +
                    '\r\n' +
                    'ぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                button: '植樹チケット',
                cloudfunding_abount: '',
                cloudfunding_description: '植樹チケット以外にも、様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_description_sp: '植樹チケット以外にも、' +
                    '\r\n' +
                    '様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_button: '支援に関するお問い合わせ',
                cloudfunding_image: './Images/cf_logo_padded.png',
                cloudfunding_url: 'https://camp-fire.jp/projects/view/314807'
            },

            // 各種SNSのリンク
            //
            // icon => アイコン
            // url => リンク先URL
            links: [{
                    icon: './Images/icon_facebook.png',
                    url: 'https://www.facebook.com/NAKEDINC.official/'
                },
                {
                    icon: './Images/icon_instagram.png',
                    url: 'https://www.instagram.com/naked_inc/'
                }
            ],
            place: [{
                    name_mb1: '日本・広島',
                    name_mb2: 'おりづるタワー',
                    image_mb: './Images/Place/mb/s00145.png',
                    name: '日本・広島 / おりづるタワー',
                    time: '2023.5.19 ー',
                    image: './Images/Place/s00145.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・大阪 ',
                    name_mb2: 'VS.（グラングリーン大阪内）',
                    image_mb: './Images/Place/mb/s00177.png',
                    name: '日本・大阪 / VS.（グラングリーン大阪内）',
                    time: '2026.4.17 ー 2026.6.15',
                    image: './Images/Place/s00177.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: '台湾・台北',
                    name_mb2: '松煙文創区',
                    image_mb: './Images/Place/mb/s00176.png',
                    name: '台湾・台北 / 松煙文創区',
                    time: '2026.1.31 ー 2026.6.30',
                    image: './Images/Place/s00176.png',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・東京',
                    name_mb2: '寺田倉庫',
                    image_mb: './Images/Place/mb/s00175.png',
                    name: '日本・東京 / 寺田倉庫',
                    time: '2026.1.10 ー 2026.3.15',
                    image: './Images/Place/s00175.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: '日本・兵庫',
                    name_mb2: '姫路城三の丸広場',
                    image_mb: './Images/Place/mb/s00174.png',
                    name: '日本・兵庫 / 姫路城三の丸広場',
                    time: '2025.11.22 ー 2025.12.11',
                    image: './Images/Place/s00174.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'http://himeji-castle-dandelion.art/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '八坂神社',
                    image_mb: './Images/Place/mb/s00173.png',
                    name: '日本・京都 / 八坂神社',
                    time: '2025.8.8 ー 2025.8.17',
                    image: './Images/Place/s00173.png',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '伏見稲荷大社',
                    image_mb: './Images/Place/mb/s00172.png',
                    name: '日本・京都 / 伏見稲荷大社',
                    time: '2025.7.19 ー 2025.8.17',
                    image: './Images/Place/s00172.png',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・兵庫',
                    name_mb2: '六甲高山植物園',
                    image_mb: './Images/Place/mb/s00171.png',
                    name: '日本・兵庫 / 六甲高山植物園',
                    time: '2025.9.20 ー 2025.12.30',
                    image: './Images/Place/s00171.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://rokkomeetsart.jp/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二条城',
                    image_mb: './Images/Place/mb/s00170.png',
                    name: '日本・京都 / 元離宮二条城',
                    time: '2025.3.14 ー 2025.4.13',
                    image: './Images/Place/s00170.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://event.naked.works/nijojo/spring/ja/'
                }, {
                    name_mb1: '中国・北京',
                    name_mb2: '遇见博物馆',
                    image_mb: './Images/Place/mb/s00168.png',
                    name: '中国・北京 / 遇见博物馆',
                    time: '2024.11.15 ー 2025.2.16',
                    image: './Images/Place/s00168.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '日吉大社 白山宮（白山姫神社）拝殿',
                    image_mb: './Images/Place/mb/s00167.png',
                    name: '日本・滋賀 / 日吉大社 白山宮（白山姫神社）拝殿',
                    time: '2024.11.1 ー 2024.12.8',
                    image: './Images/Place/s00167.png',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・石川',
                    name_mb2: '那谷寺',
                    image_mb: './Images/Place/mb/s00166.png',
                    name: '日本・石川 / 那谷寺',
                    time: '2024.10.25 ー 2024.11.24',
                    image: './Images/Place/s00166.png',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://yoru-sanpo.naked.works/natadera/'
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '比叡山延暦寺・釈迦堂',
                    image_mb: './Images/Place/mb/s00164.png',
                    name: '日本・滋賀 / 比叡山延暦寺・釈迦堂',
                    time: '2024.9.13 ー 2024.12.8',
                    image: './Images/Place/s00164.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/s00162.png',
                    name: '日本・滋賀 / 彦根城',
                    time: '2024.3.22 ー 2024.4.9',
                    image: './Images/Place/s00162.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                },
                // {
                //     name_mb1: '日本・大阪',
                //     name_mb2: 'あべのハルカス展望台「ハルカス300」',
                //     image_mb: './Images/Place/mb/s00157.png',
                //     name: '日本・大阪 / あべのハルカス展望台「ハルカス300」',
                //     time: '2023.11.28 ー 2024.3.31',
                //     image: './Images/Place/s00157.jpg',
                //     tips: '一般公開・入場料がかかります',
                //     url_msg: '詳細はこちら',
                //     url: 'https://ultraxperience.jp/0x0mugen-project/page_clf.html'
                // },
                {
                    name_mb1: '日本・大阪',
                    name_mb2: '万博記念公園',
                    image_mb: './Images/Place/mb/s00156.png',
                    name: '日本・大阪 / 万博記念公園',
                    time: '2023.12.1 ー 2023.12.25',
                    image: './Images/Place/s00156.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/s00155.png',
                    name: '日本・滋賀 / 彦根城',
                    time: '2023.11.11 ー 2023.12.9',
                    image: './Images/Place/s00155.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二条城',
                    image_mb: './Images/Place/mb/s00144.png',
                    name: '日本・京都 / 元離宮二条城',
                    time: '2023.3.16 ー 2023.4.16',
                    image: './Images/Place/s00144.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・大阪',
                    name_mb2: 'W大阪',
                    image_mb: './Images/Place/mb/s00141.png',
                    name: '日本・大阪 / W大阪',
                    time: '2022.12.15 ー 2022.12.25',
                    image: './Images/Place/s00141.jpg',
                    tips: '一般公開',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '京都国立博物館',
                    image_mb: './Images/Place/mb/s00136.png',
                    name: '日本・京都 / 京都国立博物館',
                    time: '2022.12.10 ー 2022.12.25',
                    image: './Images/Place/s00136.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '仁和寺',
                    image_mb: './Images/Place/mb/s00135.png',
                    name: '日本・京都 / 仁和寺',
                    time: '2022.12.10 ー 2022.12.18',
                    image: './Images/Place/s00135.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name: '日本・京都 / Ace Hotel Kyoto',
                    name_mb1: '日本・京都',
                    name_mb2: 'Ace Hotel Kyoto',
                    image_mb: './Images/Place/mb/s00134.png',
                    time: '2022.12.8 ー 2022.12.25',
                    image: './Images/Place/s00134.jpg',
                    tips: '一般公開',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '西本願寺・唐門',
                    image_mb: './Images/Place/mb/s00133.png',
                    name: '日本・京都 / 西本願寺・唐門',
                    time: '2022.11.24 ー 2022.11.27',
                    image: './Images/Place/s00133.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '平安神宮',
                    image_mb: './Images/Place/mb/s00132.png',
                    name: '日本・京都 / 平安神宮',
                    time: '2022.11.18 ー 2022.12.25',
                    image: './Images/Place/s00132.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '北野天満宮',
                    image_mb: './Images/Place/mb/s00131.png',
                    name: '日本・京都 / 北野天満宮',
                    time: '2022.11.12 ー 2022.11.27',
                    image: './Images/Place/s00131.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '宇治市',
                    image_mb: './Images/Place/mb/s00130.png',
                    name: '日本・宇治 / 宇治市',
                    time: '2022.11.11 ー 2022.12.4',
                    image: './Images/Place/s00130.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/2022_10_dandelion_castle_fin_web.png',
                    name: '日本・滋賀 / 彦根城',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_castle_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '比叡山麓・滋賀院門跡',
                    image_mb: './Images/Place/mb/2022_10_dandelion_monseki_fin_web.png',
                    name: '日本・滋賀 / 比叡山麓・滋賀院門跡',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_monseki_fin_web.jpg',
                    tips: '一般公開(金土日祝)・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: 'サウジアラビア・リヤド',
                    name_mb2: 'アル・ムラバ',
                    image_mb: './Images/Place/mb/2022_10_dandelion_almurabaa_fin_web.png',
                    name: 'サウジアラビア・リヤド / アル・ムラバ',
                    time: '2022.11.1 ー 2022.12.18',
                    image: './Images/Place/2022_10_dandelion_almurabaa_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二条城',
                    image_mb: './Images/Place/mb/2022_10_dandelion_nijojo_fin_web.png',
                    name: '日本・京都 / 元離宮二条城',
                    time: '2022.10.28 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_nijojo_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '上賀茂神社',
                    image_mb: './Images/Place/mb/2022_09_dandelion_kamigamoshrine_fin_web.png',
                    name: '日本・京都 / 上賀茂神社',
                    time: '2022.10.21 ー 2022.10.23',
                    image: './Images/Place/2022_09_dandelion_kamigamoshrine_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・大阪',
                    name_mb2: 'うめきた外庭SQUARE',
                    image_mb: './Images/Place/mb/2022_09_dandelion_square_fin_web.png',
                    name: '日本・大阪 / うめきた外庭SQUARE',
                    time: '2022.10.7 ー 2022.10.9',
                    image: './Images/Place/2022_09_dandelion_square_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '旧三井家下鴨別邸',
                    image_mb: './Images/Place/mb/2022_09_dandelion_oldmitsuifamily_fin_web.png',
                    name: '日本・京都 / 旧三井家下鴨別邸',
                    time: '2022.9.23 ー 2022.10.2',
                    image: './Images/Place/2022_09_dandelion_oldmitsuifamily_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '京都市役所本庁舎前',
                    image_mb: './Images/Place/mb/2022_09_dandelion_shiyakusyo_fin_web.png',
                    name: '日本・京都 / 京都市役所本庁舎前',
                    time: '2022.9.15 ー 2022.9.16',
                    image: './Images/Place/2022_09_dandelion_shiyakusyo_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '延暦寺',
                    image_mb: './Images/Place/mb/2022_07_dandelion_hieizan_pers_fin_web.png',
                    name: '日本・滋賀 / 延暦寺',
                    time: '2022.8.4 ー 2022.8.31',
                    image: './Images/Place/2022_07_dandelion_hieizan_pers_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '平安神宮',
                    image_mb: './Images/Place/mb/2021_09_dande_heianjingu_fin_web.png',
                    name: '日本・京都 / 平安神宮',
                    time: '2021.12.15 ー 2022.1.16',
                    image: './Images/Place/2021_09_dande_heianjingu_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '嵐山',
                    image_mb: './Images/Place/mb/2021_09_dande_arashiyama_fin_web.png',
                    name: '日本・京都 / 嵐山',
                    time: '2021.12.10 ー 2021.12.19',
                    image: './Images/Place/2021_09_dande_arashiyama_fin_web.jpg',
                    tips: '一般公開あり',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '興聖寺',
                    image_mb: './Images/Place/mb/2021_10_dande_koushouji_fin_web.png',
                    name: '日本・京都 / 興聖寺',
                    time: '2021.12.3 ー 2021.12.5',
                    image: './Images/Place/2021_10_dande_koushouji_fin_web.jpg',
                    tips: '一般公開あり、夜間拝観料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彦根城',
                    image_mb: './Images/Place/mb/2021_11_dande_hikono_fin_web.png',
                    name: '日本・滋賀 / 彦根城',
                    time: '2021.11.27 ー 2022.1.30',
                    image: './Images/Place/2021_11_dande_hikono_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二条城',
                    image_mb: './Images/Place/mb/2021_10_dande_kochijo_a4_fin_web.png',
                    name: '日本・高知 / 高知城',
                    time: '2021.11.19 ー 2022.01.10',
                    image: './Images/Place/2021_10_dande_kochijo_a4_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://flowers.naked.works/kochi-castle/'
                },
                {
                    name_mb1: '日本・熊本',
                    name_mb2: '熊本城',
                    image_mb: './Images/Place/mb/2021_dande_kumamotojo_0928_fin_web.png',
                    name: '日本・熊本 / 熊本城',
                    time: '2021.11.19 ー 2021.12.05',
                    image: './Images/Place/2021_dande_kumamotojo_0928_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '清水寺',
                    image_mb: './Images/Place/mb/2021_10_dande_kiyomizu_1011_fin_web.png',
                    name: '日本・京都 / 清水寺',
                    time: '2021.11.17',
                    image: './Images/Place/2021_10_dande_kiyomizu_1011_fin_web.jpg',
                    tips: '一般公開なし',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '北野天満宮',
                    image_mb: './Images/Place/mb/2021_10_dande_kitanotenmangu3_1020_fin_web.png',
                    name: '日本・京都 / 北野天満宮',
                    time: '2021.11.13 ー 2021.11.14',
                    image: './Images/Place/2021_10_dande_kitanotenmangu3_1020_fin_web.jpg',
                    tips: '一般公開・北野天満宮ライトアップと同時開催',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: 'フランス・パリ',
                    name_mb2: 'サマリテーヌ',
                    image_mb: './Images/Place/mb/2021_10_dande_pari_1025-3_web.png',
                    name: 'フランス・パリ/ サマリテーヌ',
                    time: '2021.11.8 ー 2021.11.20',
                    image: './Images/Place/2021_10_dande_pari_1025-3_web.jpg',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '仁和寺',
                    image_mb: './Images/Place/mb/2021_10_dande_ninnaji_1011_fin_web.png',
                    name: '日本・京都 / 仁和寺',
                    time: '2021.11.2',
                    image: './Images/Place/2021_10_dande_ninnaji_1011_fin_web.jpg',
                    tips: '一般公開なし',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '上賀茂神社',
                    image_mb: './Images/Place/mb/2021_09_dande_kamigamo_fin_web.png',
                    name: '日本・京都 / 上賀茂神社',
                    time: '2021.10.27',
                    image: './Images/Place/2021_09_dande_kamigamo_fin_web.jpg',
                    tips: '一般公開なし',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・東京',
                    name_mb2: 'TBS',
                    image_mb: './Images/Place/mb/2021_10_dande_TVasa_0907-2_fin_web.png',
                    name: '日本・東京 / TBS',
                    time: '2021.10.1 ー 2021.10.31',
                    image: './Images/Place/2021_10_dande_TVasa_0907-2_fin_web.jpg',
                    tips: '一般公開あり',
                    url_msg: '',
                    url: ''


                },
                {
                    name_mb1: '日本・佐賀',
                    name_mb2: '佐賀県庁展望ホール',
                    image_mb: './Images/Place/mb/2021_10_damde_saga_fin_web.png',
                    name: '日本・佐賀 / 佐賀県庁展望ホール',
                    time: '2021.9.28 ー',
                    image: './Images/Place/2021_10_damde_saga_fin_web.jpg',
                    tips: '一般公開・入場料がかかります',
                    url_msg: '詳細はこちら',
                    url: 'https://garden.naked.works/saga/'


                },
                {
                    name_mb1: '日本・埼玉',
                    name_mb2: 'ムーミンバレーパーク',
                    image_mb: './Images/Place/mb/2020_11_dande_moomin_fin_web.png',
                    name: "日本・埼玉 / ムーミンバレーパーク",
                    time: "2020.11.21 ー 2021.03.07",
                    image: "./Images/Place/2020_11_dande_moomin_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・東京',
                    name_mb2: '渋谷区立宮下公園',
                    image_mb: './Images/Place/mb/2020_09_dande_miyashita_fin_web.png',
                    name: "日本・東京 / 渋谷区立宮下公園",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_miyashita_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: 'シンガポール',
                    name_mb2: 'ガーデンズ・バイ・ザ・ベイ',
                    image_mb: './Images/Place/mb/2020_09_dande_singapore_fin_web.png',
                    name: "シンガポール / ガーデンズ・バイ・ザ・ベイ",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_singapore_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・東京',
                    name_mb2: '東京タワー',
                    image_mb: './Images/Place/mb/2021_09_dande_tokyotower_a4_fin_web.png',
                    name: "日本・東京 / 東京タワー",
                    time: "2020.11.09 ー",
                    image: "./Images/Place/2021_09_dande_tokyotower_a4_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                }
            ]
        }
    }
}